(function () {
  var observer = new MutationObserver(syncStickyPrice);

  function getCheckedTierLabel() {
    var input = document.querySelector('[class^="halo-bp-"] input[type="radio"]:checked');
    return input ? input.closest('label') : null;
  }

  function attachObserver() {
    var stickyEl = document.querySelector('sticky-add-to-cart');
    observer.disconnect();
    if (stickyEl) observer.observe(stickyEl, { childList: true, subtree: true, characterData: true });
  }

  function syncStickyPrice() {
    var label = getCheckedTierLabel();
    var priceEl = document.querySelector('.sticky-add-to-cart__price');
    if (!label || !priceEl) return;

    var priceText = label.querySelector('.halo-bp-price');
    var compareText = label.querySelector('.halo-bp-compare');
    if (!priceText) return;

    var html = '<span class="halo-sticky-price-sale">' + priceText.textContent.trim() + '</span>';
    if (compareText) {
      html += ' <span class="halo-sticky-price-compare">' + compareText.textContent.trim() + '</span>';
    }

    observer.disconnect();
    priceEl.innerHTML = html;
    attachObserver();
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[class^="halo-bp-"]')) {
      syncStickyPrice();
    }
  });

  syncStickyPrice();
  attachObserver();
})();
